import{useEffect,useRef}from"react";export const useUpdateEffect=(effect,deps=[])=>{const didUpdateRef=useRef(!1);useEffect(()=>{didUpdateRef.current&&effect(),didUpdateRef.current=!0},deps)};
//# sourceMappingURL=use-update-effect.js.map